import { getColorAsRgba } from "#lib/utils"
import { useEffect, useState } from "react"

export const useThemeColors = () => {
  const [colors, setColors] = useState({
    card: "#ffffff",
    cardForeground: "#000000",
    border: "#e5e7eb",
    popover: "#ffffff",
    popoverForeground: "#000000",
    destructive: "#16a34a",
    primary: "#16a34a",
  })

  useEffect(() => {
    const updateColors = () => {
      // Create a temporary element to get computed colors from CSS variables
      const tempEl = document.createElement("div")
      tempEl.style.backgroundColor = "var(--card)"
      tempEl.style.color = "var(--card-foreground)"
      tempEl.style.borderColor = "var(--border)"
      tempEl.style.position = "absolute"
      tempEl.style.visibility = "hidden"
      tempEl.style.pointerEvents = "none"
      document.body.appendChild(tempEl)

      const computed = getComputedStyle(tempEl)

      // Get popover colors
      const popoverEl = document.createElement("div")
      popoverEl.style.backgroundColor = "var(--popover)"
      popoverEl.style.color = "var(--popover-foreground)"
      popoverEl.style.position = "absolute"
      popoverEl.style.visibility = "hidden"
      popoverEl.style.pointerEvents = "none"
      document.body.appendChild(popoverEl)

      const popoverComputed = getComputedStyle(popoverEl)

      const tempEl2 = document.createElement("div")
      tempEl2.style.color = "var(--destructive)"
      tempEl2.style.backgroundColor = "var(--primary)"
      tempEl2.style.position = "absolute"
      tempEl2.style.visibility = "hidden"
      tempEl2.style.pointerEvents = "none"
      document.body.appendChild(tempEl2)
      const computed2 = getComputedStyle(tempEl2)

      setColors({
        card: getColorAsRgba(computed.backgroundColor) || "#ffffff",
        cardForeground: getColorAsRgba(computed.color) || "#000000",
        border: getColorAsRgba(computed.borderColor) || "#e5e7eb",
        popover: getColorAsRgba(popoverComputed.backgroundColor) || "#ffffff",
        popoverForeground: getColorAsRgba(popoverComputed.color) || "#000000",
        destructive: getColorAsRgba(computed2.color) || "#000000",
        primary: getColorAsRgba(computed2.backgroundColor) || "#000000",
      })

      document.body.removeChild(tempEl)
      document.body.removeChild(popoverEl)
      document.body.removeChild(tempEl2)
    }

    updateColors()

    // Update on theme change (dark mode toggle)
    const observer = new MutationObserver(updateColors)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    })

    // Also listen for media query changes (prefers-color-scheme)
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    mediaQuery.addEventListener("change", updateColors)

    return () => {
      observer.disconnect()
      mediaQuery.removeEventListener("change", updateColors)
    }
  }, [])

  return colors
}
